import update from 'immutability-helper'

function addChildConfig(state, pid) {
  if (state[pid] && state[pid].render === 'Tabs') {
    return {
      anchor: `tab_anchor_${state[pid].config.activeIndex}`,
    }
  }
  return {}
}

/**
 * 增加 module
 */
export function addModule(state: any, action: any, pid: string) {
  let index = null
  if (action.pid.indexOf('AnchorTabs') !== -1) {
    // TODO 组件分级判断，不用在代码中判断是否是可添加自子组件
    index = state[action.pid]['config'].activeIndex || 0
  }
  return update(state, {
    [action.id]: {
      $set: {
        pid: pid,
        id: action.id,
        className: action.className || '',
        render: action.render,
        config: update(
          {
            anchor: '0',
          },
          {
            $set: {
              anchor: index,
              ...addChildConfig(state, action.pid),
            },
          }
        ),
        childrens: [],
      },
    },
  })
}

export function deleteModule(state: any, id: string) {
  return update(state, {
    $unset: [id],
  })
}

export function setModule(state: any, node: any) {
  return update(state, {
    [node.id]: {
      $set: node,
    },
  })
}

export function addChildModule(state: any, id: string, activeId: string) {
  const activeIndex: number = state.childrens.findIndex(item => item === activeId)
  if (activeIndex > -1) {
    return update(state, {
      childrens: {
        $splice: [[activeIndex + 1, 0, id]],
      },
    })
  } else {
    return update(state, {
      childrens: {
        $push: [id],
      },
    })
  }
}

export function deleteChildModule(state: any, id: string) {
  return update(state, {
    childrens: {
      $apply: function (childrens: any) {
        return childrens.filter((cId: any) => cId !== id)
      },
    },
  })
}

export function updateComponentSort(state: any, action) {
  return update(state, {
    childrens: {
      $apply: function (elchildrens) {
        const childrens = JSON.parse(JSON.stringify(elchildrens))
        let excessive
        if (action.isUp) {
          excessive = childrens[action.index - 1]
          childrens[action.index - 1] = childrens[action.index]
          childrens[action.index] = excessive
        } else {
          excessive = childrens[action.index + 1]
          childrens[action.index + 1] = childrens[action.index]
          childrens[action.index] = excessive
        }
        return childrens
      },
    },
  })
}
